var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 1.375C2.1875 1.27145 2.27145 1.1875 2.375 1.1875H4.62499C4.72854 1.1875 4.81249 1.27145 4.81249 1.375V3.625C4.81249 3.72855 4.72854 3.8125 4.62499 3.8125C4.52145 3.8125 4.43749 3.72855 4.43749 3.625V1.5625H2.375C2.27145 1.5625 2.1875 1.47855 2.1875 1.375Z",
    fill: "#586068"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75596 1.24242C4.82919 1.31564 4.82919 1.43436 4.75596 1.50758L1.57399 4.68957C1.50077 4.7628 1.38205 4.7628 1.30882 4.68957C1.2356 4.61635 1.2356 4.49762 1.30882 4.4244L4.49079 1.24242C4.56401 1.16919 4.68274 1.16919 4.75596 1.24242Z",
    fill: "#586068"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalIcon);
export default __webpack_public_path__ + "static/media/WithdrawalIcon.453b1ec49292809e44ed8fdc83e0719f.svg";
export { ForwardRef as ReactComponent };